import { render, staticRenderFns } from "./Transactions.vue?vue&type=template&id=b6534e70&scoped=true"
import script from "./Transactions.vue?vue&type=script&lang=js"
export * from "./Transactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6534e70",
  null
  
)

export default component.exports